import React, { Component } from 'react';
import { Segment, Header, Table } from 'semantic-ui-react';

export default class Grading extends Component {
  render() {
    return (
      <Segment vertical>
        <Header as='h1' content="Grading" />
        Your grade will be calcualted as follows:
        <Table definition>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell />
              <Table.HeaderCell>% of final grade</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row>
              <Table.Cell><a href="#participation">Class participation</a></Table.Cell>
              <Table.Cell>15</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell><a href="/commentaries">Reading Commentaries</a></Table.Cell>
              <Table.Cell>20</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell><a href="/discussions">Discussion Lead</a></Table.Cell>
              <Table.Cell>15</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell><a href="/group-project">Group Research Project</a></Table.Cell>
              <Table.Cell>50</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/grading.js